const id = "150671791714175";
const UUID = "uuid";

import Fingerprint2 from "fingerprintjs2";

import {
  getLclStorageItem,
  setLclStorageItem,
  setCookie,
  getCookie
} from "./index";

export const fbSdkLogin = function() {
  return new Promise(resolve => {
    FB.login(res => {
      resolve(res);
    });
  });
};

export const fbSdkGetState = function() {
  return new Promise(resolve => {
    FB.getLoginStatus(res => {
      resolve(res);
    });
  });
};

// let doFbShare = function(href, fbAccount, shareSuccess, shareFail) {
//   FB.ui(
//     {
//       method: "share",
//       href: href
//     },
//     function(response) {
//       if (response && !response.error_message) {
//         shareSuccess(response, fbAccount);
//       } else {
//         shareFail(response, fbAccount);
//       }
//     }
//   );
// };

export let fbShare = function({ description, link, title, img }) {
  return new Promise((resolve, reject) => {
    let href = `https://eventsapi.gm99.com/fbShareCustomize/customizeShare/message/${encodeURIComponent(
      description
    )}/app_id/${encodeURIComponent(id)}/redict_url/${encodeURIComponent(
      `${link}&scid=fbshare`
    )}/share_title/${encodeURIComponent(title)}/pic_url/${encodeURIComponent(
      img
    )}`;

    console.log(href);

    FB.ui({ method: "share", href: href }, response => {
      if (response && !response.error_message) {
        resolve();
      } else {
        reject();
      }
    });
  });
};

// 邀請好友功能
export let invite = function(inviteTitle) {
  return new Promise((resolve, reject) => {
    FB.ui(
      {
        method: "apprequests",
        message: inviteTitle,
        filter: ["app_non_users"]
      },
      function(response) {
        if (response && response.hasOwnProperty("request")) {
          var request_id = response["request"];
          var invites = response.hasOwnProperty("to")
            ? response["to"].join(",")
            : "";
          resolve(true, {
            request_id,
            invites
          });
        } else {
          resolve(false, {});
        }
      }
    );
  });
};

export let fbSdkPay = function(order_id) {
  return new Promise((resolve, reject) => {
    var obj = {
      method: "pay",
      action: "purchaseitem",
      product: `https://mstore.gm99.com/facebook_local_money/product_items/app_id/${window.appInfo.appId}/order_id/${order_id}`,
      request_id: order_id
    };

    console.log(obj);

    FB.ui(obj, res => {
      if (res && !res["error_code"]) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};

export const getFingerprint = function() {
  return new Promise(resolve => {
    let locaUUid = getLclStorageItem(UUID);
    let cookUUid = getCookie(UUID);
    let saveUuid = locaUUid || cookUUid;
    if (saveUuid) {
      if (!cookUUid || (locaUUid && locaUUid !== cookUUid)) {
        setCookie(UUID, saveUuid);
      }
      if (!locaUUid) {
        setLclStorageItem(UUID, saveUuid);
      }
      resolve(saveUuid);
    } else {
      Fingerprint2.getV18(
        {
          excludes: {
            language: true
          }
        },
        function(result) {
          let timestamp = new Date().valueOf();
          let realUuid = result + timestamp;
          setLclStorageItem(UUID, realUuid);
          setCookie(UUID, realUuid);
          resolve(realUuid);
        }
      );
    }
  });
};

export const getLoginId = function() {
  let locaUUid = getLclStorageItem(UUID);
  let cookUUid = getCookie(UUID);
  return locaUUid || cookUUid || "";
};

export const lineShare = function({ link }) {
  window.open(
    `https://lineit.line.me/share/ui?url=${encodeURIComponent(link)}`,
    "_blank",
    "toolbar=yes,location=yes,directories=no,status=no,menubar=yes,scrollbars=yes,resizable=no,copyhistory=yes"
  );
};



// WEBPACK FOOTER //
// ./src/utile/fb.js